import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from "utils/AuthContext";
import Button from "components/Button";
import { PADDING } from "styles/global-style";
import { useLocation } from "react-router-dom";

export default function AuthSettingsMenu() {
  const { roleAccess } = useContext(AuthContext);
  const location = useLocation();

  const [page, setPage] = useState(null);

  useEffect(() => {
    setPage(location.pathname.split("/").at(-1));
  }, [location]);

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        rowGap: PADDING / 2,
        paddingRight: PADDING * 3,
      }}
    >
      <Button text="Account" click="/auth/settings/account" menuitem noborder active={["account", "password"].includes(page)} />
      {roleAccess("admin") && <Button text="General" click="/auth/settings/general" menuitem noborder active={page === "general"} />}
      {roleAccess("manager") && <Button text="Project" click="/auth/settings/proj" menuitem noborder active={page === "proj"} />}
      {roleAccess("manager") && <Button text="Users" click="/auth/settings/users" menuitem noborder active={page === "users"} />}
      {roleAccess("manager") && <Button text="Disciplines" click="/auth/settings/disciplines" menuitem noborder active={page === "disciplines"} />}
      {roleAccess("manager") && <Button text="DoDs" click="/auth/settings/dods" menuitem noborder active={page === "dods"} />}
      {roleAccess("manager") && <Button text="Export" click="/auth/settings/export" menuitem noborder active={page === "export"} />}
      {roleAccess("manager") && <Button text="Import" click="/auth/settings/import" menuitem noborder active={page === "import"} />}
      {roleAccess("manager") && <Button text="Organization" click="/auth/settings/org" menuitem noborder active={page === "org"} />}
      {roleAccess("admin") && <Button text="Analytics" click="/auth/settings/analytics" menuitem noborder active={page === "analytics"} />}
    </div>
  );
}
